import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../../../core/domain/Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {CardModel} from './Card.model';

@injectable()
export class CardFactory
  implements BaseDomainFactory<CardModel, CardModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: CardModel.Props): CardModel {
    return this.modelsRegistry.put(new CardModel(props));
  }
}
